import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    height: 100%;
    width: 100%;

    background-color: ${theme.co.neutral99};
    color: ${theme.co.secondary50};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
);

export const Header = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xl};
    color: ${theme.co.secondary20};
    margin: ${theme.sz.s1};
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.xs};
    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s54};
    }
  `,
);

export const PointsValues = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xxl};
    color: ${theme.co.secondary50};
    white-space: nowrap;
  `,
);

export const AccentValue = styled.span(
  ({ theme }) => css`
    color: ${theme.co.success40};
  `,
);

export const IncrementValue = styled(AccentValue)(
  ({ theme }) => css`
    position: absolute;
    margin-left: ${theme.sz.s1};
  `,
);

export const StatisticWrapper = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
);

export const PointsTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
  `,
);

export const WordsValues = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xl};
    color: ${theme.co.secondary50};
  `,
);

export const WordsTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
  `,
);

export const Divider = styled.div(
  ({ theme }) => css`
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary95};
    margin: ${theme.sz.s8} 0;
    width: ${theme.sz.xs};
  `,
);

export const WordsStatisticWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;

    justify-content: space-between;
    width: ${theme.sz.xs};
    margin-bottom: ${theme.sz.s8};
    gap: ${theme.sz.s2};
  `,
);

export const WordsStatistic = styled(StatisticWrapper)(
  () => css`
    width: 50%;
  `,
);
